import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import {
  FeatureVisibility,
  type IFeature,
} from '@principle-theorem/feature-flags';
import {
  filterUndefined,
  findProp,
  splitCamel,
  titlecase,
} from '@principle-theorem/shared';
import { camelCase } from 'lodash';

@Component({
  selector: 'pt-feature-info',
  templateUrl: './feature-info.component.html',
  styleUrls: ['./feature-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule],
})
export class FeatureInfoComponent {
  route = inject(ActivatedRoute);

  feature = toSignal(
    this.route.data.pipe(findProp<IFeature>('feature'), filterUndefined())
  );

  isAlpha = computed(
    () => this.feature()?.visibility === FeatureVisibility.Alpha
  );

  isBeta = computed(
    () =>
      this.feature()?.visibility === FeatureVisibility.Beta ||
      this.feature()?.visibility === FeatureVisibility.OptIn
  );

  featureName = computed(() => {
    const label = this.feature()?.label;
    if (!label) {
      return;
    }

    return titlecase(splitCamel(camelCase(label)));
  });
}
